import "./CompanyGeneralInfo.css";

const CompanyGeneralInfo = ({ data }) => {
	const getStatus = (obj) => {
		if (obj.status === "Ликвидирована" && data?.liquidation_date) {
			return `Ликвидирована (${data.liquidation_date})`;
		} else {
			return obj.status;
		}
	};

	return (
		<div className="CompanyGeneralInfo">
			<div className="InnKppModalDataRow">{data.full_with_opf}</div>
			<div className="InnKppModalDataRowWithCell">
				<span className="InnKppModalDataCell">ИНН: {data.inn}</span>
				<span className="InnKppModalDataCell">КПП: {data.kpp}</span>
				<span className="InnKppModalDataCell">ОГРН: {data.ogrn}</span>
				<span className="InnKppModalDataCell">Статус: {getStatus(data)}</span>
				<span className="InnKppModalDataCell">Дата регистрации: {data.registration_date}</span>
			</div>
			<div className="InnKppModalDataRow">Адрес: {data.address}</div>
			<div className="InnKppModalDataRow">
				{data.manager_post} {data.manager_name}
			</div>
		</div>
	);
};

export default CompanyGeneralInfo;
